import React from "react";
import { Link, useLocation } from "react-router-dom";
import { TID } from "../lib/testIds";

export default function HeaderBar({ config, health }) {
  const loc = useLocation();
  const mode = config?.mode;
  const isMock = mode === "mock";
  const healthOk = health?.ok;
  return (
    <header className="border-b border-[var(--kk-line)] bg-[var(--kk-black)]/85 backdrop-blur sticky top-0 z-30">
      <div className="max-w-[1400px] mx-auto px-6 py-3 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid={TID.appTitle}>
          <div className="w-8 h-8 rounded-full border border-[var(--kk-gold)] grid place-items-center text-[var(--kk-gold)] font-display text-sm">
            KK
          </div>
          <div className="leading-tight">
            <div className="font-display text-[15px] tracking-[0.22em] text-[var(--kk-gold-soft)]">
              KARA · KRUS
            </div>
            <div className="font-mono text-[10px] text-[var(--kk-muted)] uppercase tracking-[0.25em]">
              CoreBridge Studios · CB_KARAKRUS · KK001
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-6 text-[11px] uppercase tracking-[0.2em]">
          <Link
            to="/"
            className={`hover:text-[var(--kk-gold-soft)] ${loc.pathname === "/" ? "text-[var(--kk-gold-soft)]" : "text-[var(--kk-muted)]"}`}
            data-testid="nav-game"
          >
            Game
          </Link>
          <Link
            to="/admin"
            className={`hover:text-[var(--kk-gold-soft)] ${loc.pathname.startsWith("/admin") ? "text-[var(--kk-gold-soft)]" : "text-[var(--kk-muted)]"}`}
            data-testid="nav-admin"
          >
            Admin
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em]"
               data-testid={TID.modeIndicator}>
            <span className={`dot ${isMock ? "mock" : "live"}`} />
            <span className="text-[var(--kk-muted)]">Mode</span>
            <span className="text-[var(--kk-ivory)] font-mono">{mode || "—"}</span>
          </div>
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em]"
               data-testid={TID.apiStatus}>
            <span className={`dot ${healthOk ? "live" : "err"}`} data-testid={TID.cbHealthDot} />
            <span className="text-[var(--kk-muted)]">Operator API</span>
            <span className="font-mono text-[var(--kk-ivory)]">
              {healthOk ? (health?.status_code || "OK") : "DOWN"}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
